import { AxiosInstance } from "axios";
import {
  AxiosOptions,
  ContainerClass,
  ContainerClassImpl,
} from "@/libs/api/types";
import {
  CartOrderApiFactory,
  ResponseData,
  RequestData,
  RequestDataKeyPrefix,
} from "./types";

const options: AxiosOptions = {
  url: "/ajaxCart/changeOrder",
  method: "post",
  params: {},
};

export const cartOrderApiFactory = (
  axios: AxiosInstance,
  containerClass: ContainerClass = URLSearchParams
): CartOrderApiFactory => {
  return {
    /**
     * 注文データを更新する
     *
     * @returns 注文データの更新関数
     */
    updateCartOrderItems: updateCartOrderItems(axios, options, containerClass),
  };
};

/**
 * 注文データを更新する
 *
 * @param axios APIクライアント
 * @param options axiosオプション
 * @param containerClass 注入するコンテナクラス
 * @returns axiosの返り値
 */
export const updateCartOrderItems = (
  axios: AxiosInstance,
  options: AxiosOptions,
  containerClass: ContainerClass
) => (data: RequestData): Promise<ResponseData> => {
  const axiosRequestArgs = {
    ...options,
    data: createPostParams(data, containerClass),
  };
  return new Promise((resolve, reject) => {
    axios
      .request(axiosRequestArgs)
      .then((i) => {
        resolve(i.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/**
 * APIへ送信するリクエストボディを作成する
 *
 * @param data APIへ送信するリクエストボディ
 * @param containerClass 注入するコンテナクラス
 * @returns URLSearchParams オブジェクト
 */
const createPostParams = (
  data: RequestData,
  containerClass: ContainerClass
): ContainerClassImpl => {
  const params = new containerClass();
  for (const key of Object.keys(data)) {
    params.set(`${key}`, `${data[key as RequestDataKeyPrefix]}`);
  }
  return params;
};
